import React, { useState, useEffect } from 'react'
import { userList, userProfile } from '../../api/users';
import { getDownloadFile, putAPI } from "../../services/ApiService";
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import Sidebar from '../Layout/Sidebar';
import Pagination from '../Layout/Pagination';
import { DateFunc } from '../../services/Date';

// import Swal from 'sweetalert2';
import { CModal, CModalHeader, CModalTitle, CModalBody } from '@coreui/react';

function ActiveUser() {
    useEffect(() => {
        document.title = "Active Panelist - Brand Synergix"
    },);
    const [searchKeyword, setSearchKeyword] = useState();
    const [listType, setListType] = useState("active");
    const [lists, setLists] = useState();
    const [pageInfo, setPagination] = useState({})
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [detail, setDetail] = useState();
    const [visibleDetail, setVisibleDetail] = useState(false);
    const [displayRejectionBox, setdisplayRejectionBox] = useState("none");

    useEffect(() => {
        getList()
    }, [listType]);

    const changePage = (p) => {
        pageInfo.current_page = p;
        getList();
    }

    const getList = async () => {
        if (listType) {
            setSearchKeyword(document.getElementById('searchKeyWord').value);
            let payloadData = {
                listType: listType,
                q: searchKeyword ? searchKeyword : "",
                page: pageInfo.current_page ? pageInfo.current_page : 1,
                recPerPage: 50,
                from: startDate ? Math.floor(new Date(startDate + ' 00:00:00').getTime() / 1000) : "",
                to: endDate ? Math.floor(new Date(endDate + ' 23:59:59').getTime() / 1000) : ""
            }
            let res = await userList({ payload: payloadData });
            if (res.status === 1) {
                setLists(res.payload);
                setPagination(res.paginationInfo);
            } else {
                setLists([])
            }
        }
    }

    const downloadUserData = async () => {
        if (listType) {
            // set search keyword
            setSearchKeyword(document.getElementById('searchKeyWord').value);
            let payloadData = {
                listType: listType,
                q: searchKeyword ? searchKeyword : "",
                page: pageInfo.current_page ? pageInfo.current_page : 0,
                recPerPage: pageInfo.recPerPage ? pageInfo.recPerPage : 50,
                from: startDate ? Math.floor(new Date(startDate + ' 00:00:00').getTime() / 1000) : "",
                to: endDate ? Math.floor(new Date(endDate + ' 23:59:59').getTime() / 1000) : ""
            }

            await getDownloadFile("/user/download/?page=" + payloadData.page + "&recPerPage=" + payloadData.recPerPage + "&q=" + payloadData.q + "&from=" + payloadData.from + "&to=" + payloadData.to + "&listType=" + payloadData.listType, "users_" + Math.floor(new Date().getTime() / 1000));
        }
    };

    const fetchUserProfile = async (id) => {
        let res = await userProfile({ payload: { userId: id } });
        if (res.status === 1) {
            setDetail(res.payload);
            setVisibleDetail(true);
        }
    }

    const verifyOficialContactInfo = async (ID, status, userID) => {
        let reason = "";
        if (status == 0) {
            reason = document.getElementById('boardlineRejectionReason').value;
        }
        let res = await putAPI('/user/update-official-info-status/' + ID, { status, reason, userID });
        setdisplayRejectionBox("none")
        await fetchUserProfile(userID)
    }
    return (
        <div>
            <Sidebar />
            <Header />
            <div id="layout-wrapper">
                <div className="main-content">
                    <div className="page-content">
                        <div className="container-fluid">
                            {/* <!-- start page title --> */}
                            <div className="row">
                                <div className="col-12 col-lg-12 col-xl-12 col-md-12">
                                    <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                                        <div className="page-title-right">
                                            <ol className="breadcrumb m-0">
                                                <li className="breadcrumb-item">Panelist</li>
                                                <li className="breadcrumb-item active">Active</li>
                                            </ol>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            {/* <!-- end page title --> */}

                            <div className='d-flex justify-content-between align-items-center gap-3'>
                                <div className='d-flex align-items-center gap-3'>
                                    <div className="mb-3 row mx-2">
                                        <label htmlFor="Projectdescription" className="form-label mb-0">Search <span className="required_field">*</span></label>
                                        <input type="text" onKeyDown={(e) => setSearchKeyword(e.target.value)} className="form-control" placeholder='Search by name, email, phone . . .' id="searchKeyWord" />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="startDate" className="form-label mb-0">From <span className="required_field">*</span></label>
                                        <input type="date" onChange={(e) => setStartDate(e.target.value)} className="form-control" id="startDate" />
                                    </div>
                                    <div className="mb-3">
                                        <label htmlFor="endDate" className="form-label mb-0">To <span className="required_field">*</span></label>
                                        <input type="date" onChange={(e) => setEndDate(e.target.value)} className="form-control" id="endDate" />
                                    </div>
                                    <div className="mb-3 d-flex align-items-center">
                                        <button className="btn btn-primary mt-3 d-flex align-items-center gap-2" onClick={() => getList()}>
                                            <i className="mdi mdi-magnify"></i> <span>Go</span>
                                        </button>
                                    </div>
                                </div>
                                <div className='d-flex align-items-center gap-3'>
                                    
                                    <div className="mb-3 d-flex align-items-center">
                                        <button className="btn btn-primary mt-3 d-flex align-items-center gap-2" onClick={() => downloadUserData()}>
                                            <i className="mdi mdi-download"></i> <span>Download</span>
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <div className="row mt-2">
                                <div className="col-xl-12 col-lg-12">
                                    <div className="card">
                                        {/* <!-- end card header --> */}
                                        <div className="card-body">
                                            <table className="table table-striped table-hover table_client" style={{ font: "12px" }}>
                                                <thead>
                                                    <tr className="bg-orange" style={{ color: "black" }}>
                                                        <th scope="col">Sr. no.</th>
                                                        <th scope="col" style={{ textAlign: "left" }}>Name</th>
                                                        <th scope="col" style={{ textAlign: "left" }}>Phone</th>
                                                        <th scope="col" style={{ textAlign: "left" }}>Email</th>
                                                        <th scope="col" style={{ textAlign: "left" }}>Professional Details</th>
                                                        {/* <th scope="col" style={{ textAlign: "left" }}>Country</th> */}
                                                        {/* <th scope="col" style={{ textAlign: "left" }}>Type</th> */}
                                                        <th scope="col" style={{ textAlign: "left" }}>Registered On</th>
                                                        <th scope="col" style={{ textAlign: "left" }}>Status</th>
                                                        <th scope="col" style={{ textAlign: "left" }}>More</th>
                                                    </tr>
                                                </thead>
                                                <tbody className="table-body">
                                                    {lists ? (<>
                                                        {lists?.length > 0 ? (<>
                                                            {lists?.map((row, index) => {
                                                                return (
                                                                    <>
                                                                        <tr
                                                                            key={index + 1}
                                                                            id={row?.ID}
                                                                            style={{ transition: "background 0.2s" }}
                                                                            onMouseOver={e => e.currentTarget.style.background = "#bbb"}
                                                                            onMouseOut={e => e.currentTarget.style.background = ""}>
                                                                            <td>{(pageInfo.current_page - 1) * pageInfo.perPage + ++index}</td>
                                                                            <td style={{ textAlign: "left" }}>
                                                                                {row?.firstName !== null ? row?.firstName : "-"} {row?.lastName !== null ? row?.lastName : ""}
                                                                            </td>
                                                                            <td style={{ textAlign: "left" }}>{row?.mobileNumber && row?.mobileNumber !== null && row?.mobileNumber !== "" ? row?.mobileNumber : "-"}</td>
                                                                            <td style={{ textAlign: "left" }}>{row?.email}</td>
                                                                            <td style={{ textAlign: "left" }}><b>{row?.designation}</b><br/>{row?.companyName}</td>
                                                                            <td style={{ textAlign: "left" }}>{row?.joinedOn}</td>
                                                                            <td style={{ textAlign: "left" }}>
                                                                                <span className={row?.statusSlug === "verified" ? "" : row?.statusSlug === "blocked" ? "" : ""}>
                                                                                    {row?.statusTxt}
                                                                                </span>
                                                                            </td>
                                                                            <td style={{ textAlign: "left" }}>
                                                                                <div className="dropdown d-inline">
                                                                                    <button
                                                                                        className="btn btn-link p-0"
                                                                                        type="button"
                                                                                        id={`dropdownMenuButton${row?.ID}`}
                                                                                        data-bs-toggle="dropdown"
                                                                                        aria-expanded="false"
                                                                                        style={{ boxShadow: "none" }}
                                                                                    >
                                                                                        <i className="mdi mdi-dots-vertical" style={{ fontSize: "22px" }}></i>
                                                                                    </button>
                                                                                    <ul className="dropdown-menu" aria-labelledby={`dropdownMenuButton${row?.ID}`}>
                                                                                        <li>
                                                                                            <button className="dropdown-item" onClick={() => fetchUserProfile(row?.ID)}>
                                                                                                <i className="mdi mdi-eye"></i> Details
                                                                                            </button>
                                                                                        </li>
                                                                                        <li>
                                                                                            <button className="dropdown-item" disabled>
                                                                                                <i className="mdi mdi-history"></i> Activity Log
                                                                                            </button>
                                                                                        </li>
                                                                                    </ul>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    </>
                                                                )
                                                            })}
                                                        </>) : (<>
                                                            <tr>
                                                                <td colSpan={9}>No data found</td>
                                                            </tr>
                                                        </>)}
                                                    </>) :
                                                        (<></>)}
                                                </tbody>
                                            </table>
                                            <Pagination pageInfo={pageInfo} changePage={changePage} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            {/* <!-- end row--> */}
                            {/* <!-- end row --> */}
                        </div>
                        {/* <!-- container-fluid --> */}
                    </div>
                    {/* <!-- End Page-content --> */}
                </div>
            </div>
            <Footer />
            {visibleDetail ? (<>
                <>
                    {/* <CButton onClick={() => setVisibleDetail(!visibleDetail)}>Launch static backdrop modal</CButton> */}
                    <CModal visible={visibleDetail} backdrop={"static"} size={"lg"} onClose={() => setVisibleDetail(false)}>
                        <CModalHeader style={{ backgroundColor: "#405189", paddingBottom: "10px", margin: "-1px" }} closeButton={false}>
                            <CModalTitle style={{ color: "#fff", width: "100%" }}>
                                User Profile Info
                                <span style={{ float: "right", cursor: "pointer" }} onClick={() => setVisibleDetail(false)}> X </span>
                            </CModalTitle>
                        </CModalHeader>
                        <CModalBody>
                            <div className="row mt-2">
                                <div className="col-xl-12 col-lg-12">
                                    <div className="row d-flex">
                                        <div className="col-md-6">
                                            <label htmlFor="name" className="form-label">Name:</label>
                                            <span> {detail?.firstName} {detail?.lastName}</span>
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="email" className="form-label">Email:</label>
                                            <span> {detail?.email}</span>
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="phone" className="form-label">Phone:</label>
                                            <span> {detail?.mobileNumber}</span>
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="phone" className="form-label">Company:</label>
                                            <span> {detail?.companyName}</span>
                                        </div>
                                        <div className="col-md-6">
                                            <label htmlFor="phone" className="form-label">Designation
                                                :</label>
                                            <span> {detail?.designation}</span>
                                        </div>
                                        
                                    </div>
                                  
                                </div>
                            </div>
                        </CModalBody>
                    </CModal>
                </>
            </>) : (<></>)}
        </div>
    )
}

export default ActiveUser;